export enum Gender {
  Male = 1,
  Female = 2,
}

export enum MaritalStatus {
  Single = 1,
  Married = 2,
}

export enum VerificationType {
  Email = 1,
  Mobile = 2,
}

export enum Roles {
  Admin = "Admin",
  User = "User",
}

export enum Boolean {
  NO = 0,
  YES = 1,
}

export enum HttpStatusCodes {
  OK = 200,
  Created = 201,
  Unauthorized = 401,
  NotFound = 404,
  InternalServerError = 500,
  TemporaryRedirect = 307,
}

export enum StepStatus {
  Complete = "Complete",
  Current = "Current",
  Upcoming = "Cpcoming",
}

export enum GenralStatus {
  Pending = "Pending",
  InProgress = "InProgress",
  Completed = "Completed",
  Approved = "Approved",
  Rejected = "Rejected",
  Dismissed = "Dismissed",
}

export enum CourseStatus {
  Closed = "Closed",
  Open = "Open",
}
